(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-description-v2"] && !Shopify.designMode) return;
  try {
    (function () {

    // Misst die Höhe aller Tabs (auch versteckte) und setzt min-height auf den größten Wert
    function applyFixedHeight(wrapper) {
      var content = wrapper.querySelector('.pdv2-tabs-content');
      if (!content) return;

      var tabs = Array.from(content.querySelectorAll(':scope > .pdv2-tab'));
      if (!tabs.length) return;

      // Alle Tabs kurz sichtbar machen (außerhalb des Flows), um Höhen zu messen
      content.style.position = 'relative';
      tabs.forEach(function (t) {
        t.style.cssText += ';display:block!important;visibility:hidden!important;position:absolute!important;width:100%!important;';
      });

      var maxHeight = 0;
      tabs.forEach(function (t) {
        maxHeight = Math.max(maxHeight, t.offsetHeight);
      });

      // Ursprüngliche Darstellung wiederherstellen
      tabs.forEach(function (t) {
        t.style.cssText = t.style.cssText
          .replace(/display:[^;]+;?/gi, '')
          .replace(/visibility:[^;]+;?/gi, '')
          .replace(/position:[^;]+;?/gi, '')
          .replace(/width:[^;]+;?/gi, '');
      });
      content.style.position = '';

      content.style.minHeight = maxHeight + 'px';
    }

    function clearFixedHeight(wrapper) {
      var content = wrapper.querySelector('.pdv2-tabs-content');
      if (content) content.style.minHeight = '';
    }

    function buildTabs(wrapper) {
      var header = wrapper.querySelector('.pdv2-tabs-header');
      var content = wrapper.querySelector('.pdv2-tabs-content');
      if (!header || !content) return;

      var tabs = Array.from(content.querySelectorAll(':scope > .pdv2-tab'));
      if (!tabs.length) return;

      header.innerHTML = '';

      tabs.forEach(function (tab, i) {
        var title = tab.dataset.tabTitle || ('Tab ' + (i + 1));
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pdv2-tab-btn';
        btn.textContent = title;

        btn.addEventListener('click', function () {
          var btns = header.querySelectorAll('.pdv2-tab-btn');
          tabs.forEach(function (t, j) {
            t.classList.toggle('is-active', j === i);
            btns[j].classList.toggle('is-active', j === i);
          });
        });

        header.appendChild(btn);
      });

      // Erstes Tab aktivieren
      var btns = header.querySelectorAll('.pdv2-tab-btn');
      tabs.forEach(function (t, i) {
        var active = i === 0;
        t.classList.toggle('is-active', active);
        btns[i].classList.toggle('is-active', active);
      });

      // Feste Höhe anwenden wenn aktiviert
      if (wrapper.dataset.fixHeight === 'true') {
        applyFixedHeight(wrapper);
      } else {
        clearFixedHeight(wrapper);
      }
    }

    function initAll() {
      document.querySelectorAll('.pdv2-wrapper').forEach(buildTabs);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Bei Resize neu berechnen (debounced)
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        document.querySelectorAll('.pdv2-wrapper[data-fix-height="true"]').forEach(applyFixedHeight);
      }, 150);
    });

    // Theme-Editor: Section neu geladen
    document.addEventListener('shopify:section:load', initAll);

    // Theme-Editor: Tab-Block angeklickt → zum zugehörigen Tab wechseln
    document.addEventListener('shopify:block:select', function (e) {
      var tab = e.target.classList.contains('pdv2-tab')
        ? e.target
        : e.target.closest('.pdv2-tab');
      if (!tab) return;

      var wrapper = tab.closest('.pdv2-wrapper');
      if (!wrapper) return;

      var header = wrapper.querySelector('.pdv2-tabs-header');
      var content = wrapper.querySelector('.pdv2-tabs-content');
      if (!header || !content) return;

      var tabs = Array.from(content.querySelectorAll(':scope > .pdv2-tab'));
      var btns = Array.from(header.querySelectorAll('.pdv2-tab-btn'));
      var idx = tabs.indexOf(tab);
      if (idx < 0) return;

      tabs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      btns.forEach(function (b, i) { b.classList.toggle('is-active', i === idx); });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
